export const faqData = [
  {
    question: '如何註冊會員？',
    answer: `註冊流程如下：
      1. 點擊網頁右上方會員登入按鈕>註冊會員
      2. 填寫所有欄位資訊
      3. 等待審核成功會寄送Email通知
      4. 註冊成功即可登入會員

      本網站販售商品因含醫療相關用品，
      如需加入會員請先確定可以提供職業執照與醫事機構代碼，審核約需一到三個工作天，麻煩耐心等候！

      如有其他問題請至聯絡我們填寫線上表單，
      將有專員為您服務，謝謝！`,
  },
  {
    question: '訂購須知',
    answer: `現貨將於下單後三個工作天內出貨(不含例假日)
        結單時間:每週一至週五 12:00結單
        免運門檻:
        常溫商品出貨單總金額達 5000 元，可享免運優惠(未達門檻收運費100元)
        冷藏商品出貨單總金額達 7000 元，可享免運優惠(未達門檻收運費200元)

        單筆出貨單如遇常溫&冷藏同時出貨，則出貨總金額達 7000 元，享免運
        *常溫將與冷藏品一起通過冷藏方式運送`,
  },
  {
    question: '退貨須知',
    answer: `請於到貨內三天完成驗貨，若有退貨需求請於三天內與客服人員／業務窗口反應，商品須維持全新未拆封狀態，
      並自行負擔運費將貨品完整包裝寄回。`,
  },
  {
    question: '換貨須知',
    answer: `請於到貨內三天完成驗貨，若於驗貨時發現商品瑕疵問題，請於三天內與客服人員／業務窗口反應，本公司將以新品更換方式處裡。`,
  },
  {
    question: '營業時間',
    answer: '周一至周五10:30-16:30，國定假日、例假日不出貨。',
  },
];
